import { setBaseUrl, setAuthTokenGetter, customFetch } from "@workspace/api-client-react";

let initialized = false;

/**
 * Wire the workspace's `customFetch` to the right base URL and an
 * auth-token getter that pulls a JWT from Clerk.
 *
 * In dev the Vite proxy forwards `/api` → http://localhost:8081, so the
 * base URL is empty (relative paths). In prod we use VITE_API_BASE_URL.
 */
export function configureApiClient(getToken: () => Promise<string | null>): void {
  if (initialized) return;
  initialized = true;

  const baseUrl = import.meta.env.PROD ? (import.meta.env.VITE_API_BASE_URL ?? "") : "";

  setBaseUrl(baseUrl || null);
  setAuthTokenGetter(async () => {
    try {
      return await getToken();
    } catch {
      return null;
    }
  });
}

// Re-export so pages can use the typed fetcher directly until codegen
// regenerates @workspace/api-client-react with all the new endpoints.
export { customFetch };
